import { useEffect, useState } from "react";
import { Card, Button, Stack } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const TestBox = (props) => {
  const [imageUrl, setImageUrl] = useState("");
  const [colour, setColour] = useState("");
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const divStyle = {
    backgroundImage: "url('" + `/icons/${props.icon}.png` + "')",
    // backgroundColor: "rgba(0, 122, 7, 0.5)", // Green with 50% opacity
    backgroundBlendMode: "overlay", // Blends the color and image
    backgroundSize: "40%",
    backgroundPosition: "right",
    backgroundRepeat: "no-repeat",
  };

  const getBoxClasses = () => {
    return `curriculum-box box-${props.color.toLowerCase()} ${
      props.disabled ? "box-disabled" : "box-enabled"
    }`;
  };
  return (
    <div className="position-relative">
      {props.disabled ? <div className="coming-soon-overlay">Coming Soon</div> : <></>}
      <div
        className={getBoxClasses()}
        // style={divStyle}
        onClick={() => {
          if (!props.disabled) {
            return props.click();
          }
        }}
      >
        <div className="curriculum-box-title d-flex align-items-center">
          <div>{props.title}</div>
        </div>
        <div className="curriculum-icon-wrapper">
          <img src={`/icons/${props.icon}.png`} className="curriculum-icon" />
        </div>

        <div className="curriculum-box-text mt-auto d-flex align-items-center">
          <div className="">{props.content}</div>
          <span
            class="ms-auto material-symbols-outlined"
            style={{ fontSize: "2rem" }}
          >
            chevron_right
          </span>
        </div>
      </div>
    </div>
  );
};

export default TestBox;
